import React, { useEffect, useState } from 'react'
import TableActionsWrapper from 'components/Wrapper/TableActionsWrapper';
import TableSearchWrapper from 'components/Wrapper/TableSearchWrapper';
import TableWrapper from 'components/Wrapper/TableWrapper';
import { Button, Card, Col, Form, FormCheck, Modal, Row, Table } from 'react-bootstrap'
import { PencilSquare, Plus, Trash } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiUrls } from 'constants/apiUrls';
import { invoiceService } from 'services/invoiceService';
import ProgressLoader from 'components/Loader/ProgressLoader';
import { appRoutesUrls } from 'constants/appRoutesUrls';
import { ddMMyyyy, toDDMMYYYY, toDDMMYYYYHHMMSS } from 'utils/dateFormatter';
import { confirmOnCreateInvoice, deleteOnConfirm } from 'components/Confirm/ConfirmDialog';
import { commonMessage } from 'constants/commonMessage';
import { allowNumber } from 'utils/inputValidator';
import DatePicker from 'react-datepicker';
import { ButtonExportCsv, ButtonExportExcel, ButtonReset, ButtonSearch } from 'components/Buttons/Buttons';
import InvoiceItemForm from './InvoiceItemForm';
import { BiSolidChevronLeft } from 'react-icons/bi';

const InvoiceItemList = ({ customerId, customerName }) => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [isLoader, setIsLoader] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [invoiceItems, setInvoiceItems] = useState();
    const [invoiceItemId, setInvoiceItemId] = useState();
    const [selectedItemIds, setSelectedItemIds] = useState([]);
    const [checkedAll, setCheckedAll] = useState(false);
    const initialFilters = {
        orderBy: 'itemDate desc',
        customerId: customerId,
        isInvoiced: false,
        itemDateFrom: '',
        itemDateTo: '',
        challanNoFrom: '',
        challanNoTo: '',
        isActive: true
    };
    const [filters, setFilters] = useState(initialFilters);

    useEffect(() => {
        getInvoiceItems(filters);
    }, [])

    const getInvoiceItems = (filters) => {
        setCheckedAll(false);
        setSelectedItemIds([]);
        setIsLoader(true);
        invoiceService.getInvoiceItems(apiUrls.getInvoiceItems(), filters).then(res => {
            setIsLoader(false);
            let invoiceItems = res;
            if (invoiceItems && invoiceItems.length > 0) {
                invoiceItems.forEach((obj, index) => {
                    obj.isSelected = false // adding new property
                });
            }
            setInvoiceItems(invoiceItems);
        }).catch((err) => setIsLoader(false));
    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "challanNoFrom" && !allowNumber(e.target.value)) { return; }
        if (name === "challanNoTo" && !allowNumber(e.target.value)) { return; }

        setFilters((preValue) => ({
            ...preValue, [name]: (type === 'checkbox' ? checked : value)
        }));
    }

    const setItemDateFrom = (value) => {
        setFilters((preValue) => ({
            ...preValue, "itemDateFrom": value
        }));
    }

    const setItemDateTo = (value) => {
        setFilters((preValue) => ({
            ...preValue, "itemDateTo": value
        }));
    }

    const handleSearch = () => {
        getInvoiceItems(filters);
    }

    const handleReset = () => {
        setFilters(initialFilters);
        getInvoiceItems(initialFilters);
    }

    const handleExport = (option) => {

    }

    const openInvoiceItemModal = (invoiceItemId) => {
        setInvoiceItemId(invoiceItemId);
        setShowModal(true);
    }

    const onSave = () => {
        closeInvoiceItemModal(false);
        getInvoiceItems(filters);
    }

    const closeInvoiceItemModal = () => {
        setShowModal(false);
    }

    const deleteInvoiceItem = (invoiceItemId) => {
        if (invoiceItemId > 0) {
            setIsLoader(true);
            invoiceService.deleteInvoiceItem(apiUrls.deleteInvoiceItem(invoiceItemId)).then(res => {
                setIsLoader(false);
                toast.success("Invoice item deleted successfully");
                getInvoiceItems(filters);
            }).catch((err) => setIsLoader(false));
        }
    }

    const handleChecked = (e, index, invoiceItem) => {
        const { checked } = e.target;

        const _invoiceItems = [...invoiceItems];
        _invoiceItems[index] = { ...invoiceItem, isSelected: checked };

        setInvoiceItems(_invoiceItems);
        setSelectedItems(_invoiceItems);
    }

    const handleAllChecked = (e) => {
        const { checked } = e.target;
        setCheckedAll(checked);

        invoiceItems.forEach((obj) => {
            obj.isSelected = checked;
        });

        const _invoiceItems = [...invoiceItems];

        setInvoiceItems(_invoiceItems);
        setSelectedItems(_invoiceItems);
    }

    const setSelectedItems = (_invoiceItems) => {
        const _invoiceItemIds = _invoiceItems.filter((obj) => obj.isSelected === true).map(obj => obj.id);
        setSelectedItemIds(_invoiceItemIds);

        if (_invoiceItems?.length === _invoiceItemIds?.length)
            setCheckedAll(true);
        else
            setCheckedAll(false);
    }

    const createInvoice = () => {
        const invoice = {
            customerId: customerId,
            invoiceNo: '',
            invoiceDate: new Date(),
            prevBalance: 0,
            gstPerc: 0,
            invoiceItems: selectedItemIds
        }

        if (invoice.customerId > 0 && selectedItemIds && selectedItemIds.length > 0) {
            setIsLoader(true);
            invoiceService.addInvoice(apiUrls.addInvoice(), invoice).then((res) => {
                setIsLoader(false);
                if (res > 0) {
                    toast.info("Invoice created successfully!");
                    navigate(appRoutesUrls.invoicedetails(res));
                } else {
                    setIsLoader(false);
                    toast.error(commonMessage.somethingWrong());
                }
            }).catch((err) => setIsLoader(false));
        }
    }

    return (
        <>
            {isLoader && <ProgressLoader />}
            <Card className='card-default'>
                <Card.Body>
                    <Card.Title>
                        <span className="hand me-1">
                            <BiSolidChevronLeft size={26} onClick={() => navigate(appRoutesUrls.customerInvoices(customerId))} />
                        </span>
                        Invoice Items {invoiceItems && `(${invoiceItems?.length})`} - <b>{customerName}</b>
                    </Card.Title>
                    <TableSearchWrapper>
                        <Form noValidate>
                            <Row>
                                {!customerId > 0 && (
                                    <Col md={3}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Customer Name"
                                            name='customerName'
                                            value={filters.customerName}
                                            onChange={handleChange}
                                            maxLength={20}
                                            className="mb-3" />
                                    </Col>
                                )}
                                <Col md={3}>
                                    <DatePicker
                                        placeholderText="From Item Date"
                                        selected={filters.itemDateFrom}
                                        onSelect={setItemDateFrom}
                                        dateFormat={ddMMyyyy}
                                        className="form-control mb-3" />
                                </Col>
                                <Col md={3}>
                                    <DatePicker
                                        placeholderText="To Item Date"
                                        selected={filters.itemDateTo}
                                        onSelect={setItemDateTo}
                                        dateFormat={ddMMyyyy}
                                        className="form-control mb-3" />
                                </Col>
                                <Col md={2}>
                                    <Form.Control
                                        type="text"
                                        placeholder="From Ch.No"
                                        name='challanNoFrom'
                                        value={filters.challanNoFrom}
                                        onChange={handleChange}
                                        maxLength={10}
                                        className="mb-3" />
                                </Col>
                                <Col md={2}>
                                    <Form.Control
                                        type="text"
                                        placeholder="To Ch.No"
                                        name='challanNoTo'
                                        value={filters.challanNoTo}
                                        onChange={handleChange}
                                        maxLength={10}
                                        className="mb-3" />
                                </Col>
                                <Col md={2} className="text-right">
                                    <ButtonSearch onClick={handleSearch} />
                                    <ButtonReset onClick={handleReset} />
                                </Col>
                            </Row>
                        </Form>
                    </TableSearchWrapper>
                    <TableActionsWrapper>
                        <Row className='mt-1'>
                            <Col sm={8}>
                                <Button
                                    size="sm"
                                    variant="primary"
                                    type="button"
                                    className='mw-100'
                                    onClick={() => openInvoiceItemModal(0)}>
                                    <Plus size={24} /> Invoice Item ({invoiceItems?.length})
                                </Button>
                                <Button
                                    size="sm"
                                    variant="secondary"
                                    type="button"
                                    className='mw-100 ms-1'
                                    onClick={() => confirmOnCreateInvoice(createInvoice, null, (checkedAll ? "All" : `${selectedItemIds.length} of ${invoiceItems?.length}`))}
                                    disabled={!selectedItemIds?.length > 0}>
                                    <Plus size={24} /> Create Invoice
                                </Button>
                                <b className='text-muted ms-1'>Selected ({checkedAll ? "All" : selectedItemIds.length})</b>
                            </Col>
                            <Col sm={4} className='text-right'>
                                <ButtonExportExcel onClick={() => handleExport('excel')} />
                                <ButtonExportCsv onClick={() => handleExport('csv')} />
                                <FormCheck
                                    type="switch"
                                    className='ms-2 pull-right'
                                    label=""
                                    onChange={() => setShowMore(!showMore)}
                                    title={`Show ${showMore ? 'Less' : 'More'} Columns`}
                                />
                            </Col>
                        </Row>
                    </TableActionsWrapper>
                    <TableWrapper>
                        <Table striped hover responsive size='sm'>
                            <thead>
                                <tr>
                                    <th style={{ width: '60px' }}>Action</th>
                                    <th style={{ width: '60px' }}>
                                        <Form.Check
                                            type="checkbox"
                                            name='selectAllItem'
                                            checked={checkedAll}
                                            onChange={handleAllChecked}
                                            label=""
                                            style={{ height: '25px' }}
                                        />
                                    </th>
                                    <th style={{ width: '50px' }}>No.</th>
                                    <th style={{ width: '100px' }}>Item Date</th>
                                    <th style={{ width: '100px' }}>Ch.No</th>
                                    <th style={{ minWidth: '200px' }}>Item Description</th>
                                    <th>HSNC</th>
                                    <th style={{ textAlign: 'right' }}>Qty</th>
                                    <th style={{ textAlign: 'right' }}>Rate</th>
                                    <th style={{ textAlign: 'right' }}>Amount</th>
                                    {showMore &&
                                        <>
                                            <th>Added Date</th>
                                            <th>Added By</th>
                                            <th>Modified Date</th>
                                            <th>Modified By</th>
                                        </>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {invoiceItems && invoiceItems.map((invoiceItem, index) => (
                                    <tr key={index}>
                                        <td>
                                            <Button
                                                variant="outline-primary"
                                                className='btn-action ms-1'
                                                size='sm'
                                                onClick={() => openInvoiceItemModal(invoiceItem.id)}>
                                                <PencilSquare />
                                            </Button>
                                            {invoiceItem.isActive &&
                                                <Button
                                                    variant="outline-danger"
                                                    onClick={() => deleteOnConfirm(invoiceItem.id, deleteInvoiceItem, null)}
                                                    className='btn-action ms-1'
                                                    size='sm' >
                                                    <Trash />
                                                </Button>
                                            }
                                        </td>
                                        <td>
                                            <Form.Check
                                                type="checkbox"
                                                name="isSelected"
                                                checked={invoiceItem.isSelected}
                                                onChange={(e) => handleChecked(e, index, invoiceItem)}
                                                label=""
                                            />
                                            {JSON.stringify(invoiceItem.selected)}
                                        </td>
                                        <td>{(index + 1)}</td>
                                        <td>{toDDMMYYYY(invoiceItem.itemDate)}</td>
                                        <td>{invoiceItem.challanNo}</td>
                                        <td>{invoiceItem.itemName}</td>
                                        <td>{invoiceItem.hsnCode}</td>
                                        <td align='right'>{invoiceItem.quantity}</td>
                                        <td align='right'>{invoiceItem.unitPrice}</td>
                                        <td align='right'>{invoiceItem.itemAmount}</td>
                                        {showMore &&
                                            <>
                                                <td>{toDDMMYYYYHHMMSS(invoiceItem.addedDate)}</td>
                                                <td>{invoiceItem.addedBy}</td>
                                                <td>{toDDMMYYYYHHMMSS(invoiceItem.modifiedDate)}</td>
                                                <td>{invoiceItem.modifiedBy}</td>
                                            </>
                                        }
                                    </tr>
                                ))}
                            </tbody>
                            {/* <tfoot style={{ textAlign: 'right' }}>
                                <tr>
                                    <th colSpan={8}>Items Amount</th>
                                    <th>{invoiceDetails?.invoice?.itemsAmount}</th>
                                    {showMore && <th colSpan={4}></th>}
                                </tr>
                                <tr>
                                    <th colSpan={8}>Discount</th>
                                    <th>-{invoiceDetails?.invoice?.disAmount}</th>
                                    {showMore && <th colSpan={4}></th>}
                                </tr>
                                <tr>
                                    <th colSpan={8}>Total Amount</th>
                                    <th>{invoiceDetails?.invoice?.disAmount}</th>
                                    {showMore && <th colSpan={4}></th>}
                                </tr>
                                <tr>
                                    <th colSpan={8}>GST ({invoiceDetails?.invoice?.gstPerc}%)</th>
                                    <th>+{invoiceDetails?.invoice?.gstAmount}</th>
                                    {showMore && <th colSpan={4}></th>}
                                </tr>
                                <tr>
                                    <th colSpan={8}>Prev. Balance</th>
                                    <th>+{invoiceDetails?.invoice?.prevBalance}</th>
                                    {showMore && <th colSpan={4}></th>}
                                </tr>
                                <tr>
                                    <th colSpan={8}>Invoice Amount</th>
                                    <th>{invoiceDetails?.invoice?.invoiceAmount}</th>
                                    {showMore && <th colSpan={4}></th>}
                                </tr>
                            </tfoot> */}
                        </Table>
                    </TableWrapper>
                </Card.Body>
            </Card>
            <Modal size="md" backdrop="static" centered show={showModal} onHide={closeInvoiceItemModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Add Customer Invoice Item<br />
                        <small>{customerName}</small>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InvoiceItemForm
                        id={invoiceItemId}
                        customerId={customerId}
                        invoiceId={null}
                        onSave={onSave}
                        onCancel={closeInvoiceItemModal} />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default InvoiceItemList;